var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.12375 0.53625 0.2475 1.0725 0.375 1.625 C1.12206016 4.4638286 2.05303364 7.22223202 3 10 C1.68 10.33 0.36 10.66 -1 11 C0.65 11.33 2.3 11.66 4 12 C4 13.32 4 14.64 4 16 C-0.62 16 -5.24 16 -10 16 C-9 12 -9 12 -7.375 9.0625 C-5.8700409 5.71054563 -5.89219791 4.42411555 -7 1 C-4.53721199 -0.231394 -2.7204945 -0.07159196 0 0 Z ",
    fill: "#B7B7B7",
    transform: "translate(36,9)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.670625 0.061875 1.670625 0.061875 3.375 0.125 C3.705 1.445 4.035 2.765 4.375 4.125 C2.725 4.125 1.075 4.125 -0.625 4.125 C-0.625 5.115 -0.625 6.105 -0.625 7.125 C1.025 7.455 2.675 7.785 4.375 8.125 C3.715 9.445 3.055 10.765 2.375 12.125 C-3.375 11.375 -3.375 11.375 -5.625 9.125 C-5.875 5.625 -5.875 5.625 -5.625 2.125 C-3.625 0.125 -3.625 0.125 0 0 Z ",
    fill: "#BABABA",
    transform: "translate(48.625,13.875)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 2 2 2 2.1953125 4.1640625 C2.17210937 4.97617187 2.14890625 5.78828125 2.125 6.625 C2.10695313 7.44226563 2.08890625 8.25953125 2.0703125 9.1015625 C2.03550781 10.04128906 2.03550781 10.04128906 2 11 C1.01 11.33 0.02 11.66 -1 12 C-1.66 11.34 -2.32 10.68 -3 10 C-4.64991582 9.29289322 -6.31562256 8.62056011 -8 8 C-7.7525 7.1028125 -7.7525 7.1028125 -7.5 6.1875 C-6.8885876 3.88655664 -6.8885876 3.88655664 -7 1 C-4.48718205 -0.25640898 -2.78302919 -0.20872719 0 0 Z ",
    fill: "#C2C2C2",
    transform: "translate(15,14)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C6.67 1.65 6.34 3.3 6 5 C5.34 5 4.68 5 4 5 C4.99 6.485 4.99 6.485 6 8 C6.3125 11.0625 6.3125 11.0625 6 14 C5.01 14.66 4.02 15.32 3 16 C1.20300652 13.25165703 0.95376937 12.25170009 1.5625 8.9375 C1.706875 7.968125 1.85125 6.99875 2 6 C0.68681738 4.10041919 0.68681738 4.10041919 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z ",
    fill: "#C3C3C3",
    transform: "translate(17,9)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 1.65 3.96 3.3 6 5 C4.99796679 8.00609963 4.39971554 9.06176821 2 11 C1.01 11 0.02 11 -1 11 C-1.22174933 9.54364629 -1.42698698 8.08477044 -1.625 6.625 C-1.74101563 5.81289063 -1.85703125 5.00078125 -1.9765625 4.1640625 C-1.98429687 3.44992188 -1.99203125 2.73578125 -2 2 C-1.34 1.34 -0.68 0.68 0 0 Z ",
    fill: "#B3B3B3",
    transform: "translate(57,14)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C14.67 0.99 14.34 1.98 14 3 C9.38 3 4.76 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#D6D6D6",
    transform: "translate(26,22)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C6.67 1.65 6.34 3.3 6 5 C5.34 5 4.68 5 4 5 C3.67 5.66 3.34 6.32 3 7 C1.68 5.68 0.36 4.36 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z ",
    fill: "#A5A5A5",
    transform: "translate(17,9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.cb2cfdd230cd7b4d4989eccbd3f13987.svg";
export { ForwardRef as ReactComponent };